import React, { useEffect, useState } from 'react'
import { withFormik, Form, Field } from 'formik'
import { Link} from 'react-router-dom'
import InfoBox from './InfoBox'
import { selfRegister, appUrls } from '../utils/authService';
import { withTranslation } from 'react-i18next';
import PasswordStrengthMeter from './PasswordStrengthMeter'
import PhoneNumberField from './PhoneNumberField'


const validate = (values, props) => {
  let errors = {};

  if (!values.givenName) {
    errors.givenName = props.t('enterFirstName');
  }
  if (!values.familyName) {
    errors.familyName = props.t('enterLastName');
  }

  if (!values.userName) {
    errors.userName = props.t('enterUserName');
  }

  if (values.userName.includes(' ')) {
    errors.userName = props.t('invalidUserName');
  }

  if (values.userName.includes('#')) {
    errors.userName = props.t('invalidUserName');
  }

  if (values.userName.includes('&')) {
    errors.userName = props.t('invalidUserName');
  }


  if (!values.email) {
    errors.email = props.t('emailRequired');
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i.test(values.email)) {
    errors.email = props.t('invalidEmail');
  }

  if (!values.password) {
    errors.password = props.t('passwordRequired');
  }

  if (values.password.toLowerCase() === values.password) {
    errors.password = props.t('passwordQualify');
  }

  if (values.password.toUpperCase() === values.password) {
    errors.password = props.t('passwordQualify');
  }

  if(!/\d/.test(values.password)) {
    errors.password = props.t('passwordQualify');
  }

  if (values.password.length < 8) {
    errors.password = props.t('passwordQualify');
  }

  if (!/[_()~`!#@$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(values.password)) {
    errors.password = props.t('passwordQualify');
  }
  
  if(!errors.password) {
    if (values.password.toLowerCase().includes(values.userName.toLowerCase()) && values.userName !== "") {
      errors.password = props.t('passwordContainUsername');
    }
  
    if (values.password.toLowerCase().includes(values.givenName.toLowerCase()) && values.givenName !== "") {
      errors.password = props.t('passwordContainFirstName');
    }
  
    if (values.password.toLowerCase().includes(values.familyName.toLowerCase()) && values.familyName !== "") {
      errors.password = props.t('passwordContainLastname');
    }
  }

  if(values.password.indexOf(".")  >= 0 ) {
    errors.password = props.t('passwordContainPeriod');
  }

  if (values.phone.trim().length > 0) {
    let digits = values.phone.replace(/[^0-9]/gi, '')

    if (!/[0-9]{10}/.test(digits)) {
      errors.phone = props.t('invalidPhone')
    }
  }

  if (!values.confirmPassword) {
    errors.confirmPassword = props.t('confirmPassword');
  } else if (values.confirmPassword !== values.password) {
    errors.confirmPassword = props.t('matchPassword')
  }

  return errors;
};

const styles = {
  display: 'none',
}


const RegistrationComponent = (props) => {
  const {
    values,
    handleChange,
    setFieldValue,
    setFieldTouched,
    dirty,
    errors,
    t,
    touched,
    isSubmitting
  } = props

  useEffect(() => {
    document.title = `City of Seattle | ${t('registration')}`
  }, [t]);

  const [capsLock, setCapsLock] = useState(false);

  const handleKeyDown = (e) => {
    const checkLock = e.getModifierState('CapsLock');
    if(checkLock) {
      setCapsLock(checkLock);
    } else {
      setCapsLock(checkLock);
    }
  }
    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    
    values.appName = getParameterByName('appName');
    (function () {
        appUrls(values.appName).then((response) => {
            document.getElementById("loginLink").href = response.data.loginUrl;           
        });
    }());
    
  return (
    <div>
      <h2>{t('registration')}</h2>
      <Form className="App-form" onKeyDown={handleKeyDown}>
        <div className={"form-group form-group-lg " + (errors.userName && touched.userName ? 'has-error' : '')}>
          <label htmlFor="userName" className="control-label">{t('userName')} <span className="text-danger">*</span></label>
          <Field type="userName" className="form-control" name="userName" value={values.userName} maxLength="50" onChange={handleChange} />
          {errors.userName && touched.userName && <div className="text-danger exception-margin" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            <span className="sr-only">Error:</span>
            &nbsp;{touched.userName && errors.userName}
          </div>}
        </div>

        <div className={"form-group form-group-lg " + (errors.givenName && touched.givenName ? 'has-error' : '')}>
          <label htmlFor="givenName" className="control-label">{t('firstName')} <span className="text-danger">*</span></label>
          <Field type="text" className="form-control" name="givenName" value={values.givenName} maxLength="50" onChange={handleChange} />
          {errors.givenName && touched.givenName && <div className="text-danger exception-margin" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            <span className="sr-only">Error:</span>
            &nbsp;{touched.givenName && errors.givenName}
          </div>}
        </div>
        <div className={"form-group form-group-lg " + (errors.familyName && touched.familyName ? 'has-error' : '')}>
          <label htmlFor="familyName" className="control-label">{t('lastName')} <span className="text-danger">*</span></label>
          <Field type="familyName" className="form-control" name="familyName" value={values.familyName} maxLength="50" onChange={handleChange} />
          {errors.familyName && touched.familyName && <div className="text-danger exception-margin" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            <span className="sr-only">Error:</span>
            &nbsp;{touched.familyName && errors.familyName}
          </div>}
        </div>
        <div className={"form-group form-group-lg " + (errors.email && touched.email ? 'has-error' : '')}>
          <label htmlFor="email" className="control-label">{t('email')} <span className="text-danger">*</span></label>
          <Field type="email" aria-describedby="emailAddressHelpBlock" className="form-control" name="email" maxLength="50" placeholder={t('placeholdEmail')} value={values.email} onChange={handleChange} />
          {errors.email && touched.email && <div className="text-danger exception-margin" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            <span className="sr-only">Error:</span>
            &nbsp;{touched.email && errors.email}
          </div>}
        </div>

        <div className={"form-group form-group-lg " + (errors.phone && touched.phone ? 'has-error' : '')}>
          <label htmlFor="phone" className="control-label">{t('phone')} <span className="text-danger"></span></label>
          <PhoneNumberField phone={values.phone} setFieldValue={setFieldValue} setFieldTouched={setFieldTouched} />
          {errors.phone && touched.phone && <div className="text-danger exception-margin" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            <span className="sr-only">Error:</span>
            &nbsp;{touched.phone && errors.phone}
          </div>}
        </div>

        <div className={"form-group form-group-lg password-form-group " + (errors.password && touched.password ? 'has-error' : '')}>
          <label htmlFor="password" className="control-label">{t('password')} <span className="text-danger">*</span></label>
          <Field type="password" className="form-control password-field" name="password" value={values.password} maxLength="20" onChange={handleChange} />
          {capsLock && ( 
            <div className="exception-margin invalid-password" style={{marginBottom: '10px'}}>
              <span className="text-warning" role="alert">
                <span className="glyphicon glyphicon-warning-sign" aria-hidden="true"></span>
                <span className="sr-only">{t('capsLockIsOn')}</span>
              </span>
              {t('capsLockIsOn')}
            </div>
          )}
          <PasswordStrengthMeter password={values.password} />
          {errors.password && touched.password && <div className="text-danger exception-margin invalid-password" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            <span className="sr-only">Error:</span>
            &nbsp;{touched.password && errors.password}
          </div>}
          <p className="password-policy">{t('passwordPolicy')}</p>
        </div>

        <div className={"form-group form-group-lg " + (errors.confirmPassword && touched.confirmPassword ? 'has-error' : '')}>
          <label htmlFor="confirmPassword" className="control-label">{t('confirmPassword')} <span className="text-danger">*</span></label>
          <Field type="password" className="form-control" name="confirmPassword" value={values.confirmPassword} maxLength="20" onChange={handleChange} />
          {errors.confirmPassword && touched.confirmPassword && <div className="text-danger exception-margin" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            <span className="sr-only">Error:</span>
            &nbsp;{touched.confirmPassword && errors.confirmPassword}
          </div>}
        </div>

        <div style={styles}>
          <Field name="userType" />
        </div>

        <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={ !dirty || Object.keys(errors).length !== 0 || isSubmitting}>{t('register')}</button>
      </Form>
      <div className="return-link">
              <p>{t('alreadyRegistered')} <a id="loginLink" href="">Login</a></p>
      </div>
      <InfoBox></InfoBox>
    </div>

  )
}

const Registration = withFormik({
  mapPropsToValues({ givenName, familyName, email, userName, phone, password, confirmPassword, userType, showNotification, hideNotification }) {
    return {
      givenName: givenName || '',
      familyName: familyName || '',
      email: email || '',
      userName: userName || '',
      phone: phone || '',
      password: password || '',
      confirmPassword: confirmPassword || '',
      userType: userType || '',
      showNotification,
      hideNotification,
    }
  },
  validate: validate,
  handleSubmit(values, { props, resetForm, setSubmitting }) {
    let { givenName, familyName, email, userName, phone, password, userType } = values;
      phone = phone.replace(/[^0-9]/gi, '')
      var appName = values.appName;
    const credentials = { givenName, familyName, email, userName, phone, password, userType, appName };

    selfRegister(credentials).then(response => {
      props.history.push({
        pathname: '/registration-successful',
        state: {
          email: email,
          accountRegister: true
        }
      });

      props.showNotification({
        type: 'success',
        title: props.t('registrationSuccessTitle'),
        message: props.t('registrationSuccess', { email })
      });

    }).catch((error) => {
      let message = (error.response && error.response.data && error.response.data.detail) ? error.response.data.detail : props.t('registrationFailed');

      if (message.includes('The password does not meet the criteria of the password policy because:')) {
        let index = 0;
        let newMessage = 'The password does not meet the criteria of the password policy because: The password cannot contain ';

        if (message.includes('First Name of the user')) {
          newMessage += GetConjuctionWord(index);
          newMessage += 'First Name';
          index++;
        }

        if (message.includes('Last Name of the user')) {
          newMessage += GetConjuctionWord(index);
          newMessage += 'Last Name';
          index++;
        }

        if (message.includes('user name')) {
          newMessage += GetConjuctionWord(index);
          newMessage += 'username';
          index++;
        }

        message = newMessage + '.';
      }

      function GetConjuctionWord(index) {
        let ret = "";
        switch (index) {
          case 0:
            ret = 'the ';
            break;
          case 1:
            ret = ', ';
            break;
          case 2:
            ret = ' or ';
            break;
          default:
            ret = 'the ';
            break;
        }

        return ret;
      }

      setSubmitting(false);
      props.showNotification({
        type: 'failure',
        title: props.t('registrationFailedTitle'),
        message: message.replace('User Name', 'username')
      });
    }).finally(() => {
      setSubmitting(false);
    });
  }
})(RegistrationComponent)

export default withTranslation()(Registration);
